import { format } from "d3-format";
/**
 * Generates an array of equity scores for the table
 * @param {string} text_template - The template with one or more dynamic variables to swap in
 * @param {Record<string, string | null>} vars - Key-value pairs of variables to swap into the template
 * @returns {string} The formatted text string
 */
export function formatTextTemplate(text_template, vars) {
  let result = text_template;
  for (const key in vars) {
    if (vars[key] === null) {
      continue;
    }
    result = result.replaceAll(`[${key}]`, vars[key]);
  }
  return result;
}

/**
 *  @typedef {"percent" | "percentNum" | "number" | "numberAbbr" | "dollars" | "dollarsAbbr" | "dollarsCents"} Format
 */

/**
 * @type {Record<Format, (d: string | number | null, naLabel: string) => string>}
 */
export const FORMATTERS = {
  percent: (/** @type {string | number | null } */ d, naLabel = "N/A") => {
    return d !== null ? (typeof d === "string" ? d : format(".1%")(d)) : naLabel;
  },
  percentNum: (/** @type {string | number | null } */ d, naLabel = "N/A") => {
    return d !== null ? (typeof d === "string" ? d : format(".1f")(d * 100)) : naLabel;
  },
  number: (/** @type {string | number | null } */ d, /** @type {string} */ naLabel = "N/A") => {
    return d ? (typeof d === "string" ? d : format(",.0f")(d)) : naLabel;
  },
  numberAbbr: (/** @type {string | number | null } */ d, naLabel = "N/A") => {
    return d ? (typeof d === "string" ? d : format(".2s")(d).replace("G", "B")) : naLabel;
  },
  dollars: (/** @type {string | number | null } */ d, naLabel = "N/A") => {
    return d !== null ? (typeof d === "string" ? d : format("$,.0f")(d)) : naLabel;
  },
  dollarsAbbr: (/** @type {string | number | null } */ d, naLabel = "N/A") => {
    return d ? (typeof d === "string" ? d : format("$.2s")(d).replace("G", "B")) : naLabel;
  },
  dollarsCents: (/** @type {string | number | null } */ d, naLabel = "N/A") => {
    return d !== null ? (typeof d === "string" ? d : format("$,.2f")(d)) : naLabel;
  },
};

/**
 * @param {string | number} val
 * @param {Format} fmt
* @param {string} [naLabel="N/A"]
 * @returns {string}
 */
export function formatNumber(val, fmt, naLabel = "N/A") {
  if (Object.keys(FORMATTERS).includes(fmt)) {
    return FORMATTERS[fmt](val, naLabel);
  }
  if (typeof val !== "string") {
    return val.toString();
  }
  return val;
}
